import '../styles/about.css';
import { Col, Container } from 'react-bootstrap';
import selfImg from '../assets/img/collage no-bg.png';
import { renderTextBlock } from '../components/RenderTextBlocks';
import GameLink from '../components/GameLink';
import { useProjectTracker } from '../useProjectTracker';
import { useMediaQuery } from 'react-responsive';

function About() {
    useProjectTracker();
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <section className='about'>
            <div className="about-banner" id="home">
                <Container className="width-base banner-container">
                    <div className="banner-text banner-row align-items-center justify-content-center text-center">
                        <Col size={12} md={7} className="banner-col banner-col-left">
                            <h1 className={isMobile ? "h1-mobile" : ""}>About me<span style={{ color: "var(--color-accent)", transition: "color 0.2s ease-in-out" }}>.</span></h1>
                            <div className="a-description">
                                {renderTextBlock(`Hi! I'm **Lucas Coutinho**, a brazilian game programmer currently working at [Izyplay Game Studio](https://izyplay.com.br/). I work mostly with Unity engine but I'm always exploring new tech 🕹️

Besides work, I’m currently doing a bachelor's degree in Digital Games at **PUC Minas**, and my goal is to become a technical artist.`)}
                            </div>
                        </Col>

                        <Col size={12} md={5} className="banner-col banner-col-right" style={{ alignSelf: "center" }}>
                            <img src={selfImg} alt="Portrait" className="about-image" style={{ maxHeight: "31rem" }} />
                        </Col>
                    </div>
                </Container>
            </div>

            {/* <div className='about-width-top'>
                <div className="about-top">
                    <Col size={12} md={7} className="banner-col banner-col-left" style={{ alignSelf: "center" }}>

                    </Col>

                    <Col size={12} md={5} className="banner-col banner-col-right" style={{ alignSelf: "center" }}>
                        <img src={selfImg} alt="Portrait" className="about-image loading-bg" style={{ maxHeight: "31rem" }} />
                    </Col>
                </div>
            </div> */}

            <div className='about-width-body'>
                <div className="about-body">
                    <Col size={8} md={8} sm={12} className="a-left-container">
                        <div className="a-left about-left">

                            <div className="a-subtitle">
                                Coding games. Creating worlds
                            </div>

                            <div className="a-description">
                                {renderTextBlock(`I've been passionate about games since I was a kid, always creating worlds and stories of my own. But I only realized that I wanted to pursue game development as a career later in my life.

I'm very fascinated by the intersection of art and technology and I enjoy learning about render pipelines, shaders, software architecture and game optimizations. When working on a project I like to have a macro vision, touch every part of the project or at least have a solid understanding of the whole 👾

Besides playing and making games I enjoy watching anime, movies, travel vlogs and the occasional skateboard session. I also love diving into creative projects whether it’s painting, digital art, or 3D modeling and even experimenting with music on the side.`)}
                            </div>
                        </div>

                    </Col>

                </div>
            </div>

            <div className="a-top-link" style={{ paddingBottom: "5rem" }}>
                <Col size={12} md={12} sm={12} className="a-right-container">
                    <div className="a-right-no-bg">
                        <GameLink
                            gameName=""
                            overrideCta='Check out my experience & education'
                            overrideTitle='The road so far'
                            isSelfLink={true}
                            data={[{ type: 'overall', url: "/curriculum" }]}
                        />
                    </div>
                </Col>
            </div>

        </section>);
}

export default About;